import { NavPayloadAction } from '@carvana/merch-native';

export function getNativeVdpPayload(vehicleId?: number) {
  return JSON.stringify({
    action: NavPayloadAction.ViewVdp,
    vehicleId
  });
}

export const nativeStcPayload = JSON.stringify({
  action: NavPayloadAction.ViewTrades
});

export const nativeSrpPayload = JSON.stringify({
  action: NavPayloadAction.ViewSrp
});

export const nativeMyCarsPayload = JSON.stringify({
  action: NavPayloadAction.ViewMyCars
});

export const nativeTermsPayload = JSON.stringify({
  action: NavPayloadAction.ViewFinancing
});
